export enum Network {
  GOERLI = 'goerli',
  MAINNET = 'mainnet',
  SEPOLIA = 'sepolia'
}
